import {Injectable} from '@angular/core';
import ArtistModel from '../../model/artist.model';
import {HttpClient} from '@angular/common/http';
import Pagination from '../../model/pagination';
import GenericCrudService from "../genericCrud.service";

@Injectable()
export default class ArtistService extends GenericCrudService<ArtistModel> {
  private artistsStore = {} as { [x: string]: { items: Pagination<ArtistModel>, created: Date } };

  public constructor(protected http: HttpClient) {
    super(http);
  }

  getApiName() {
    return 'artists';
  }
}
